import {TemplateList} from "~/libs/constants/TemplateList"
import type StaticMenuItem from "~/libs/interfaces/StaticMenuItem"

export const MenuHeaderConfig: Record<TemplateList, StaticMenuItem[]> = {
  [TemplateList.POGGERS]: [
    {
      name: 'Gaming',
      url: 'gaming',
      filters: {
        categoryIds: [
          '018809f6-e3a6-3b50-dc9a-a89074d61038',
        ],
      },
    },
    {
      name: 'Pop culture',
      url: 'pop-culture',
      filters: {
        categoryIds: [
          '0187be21-8891-c95c-3b64-061e55345058',
        ],
      },
    },
    {
      name: 'Internet',
      url: 'internet',
      filters: {
        categoryIds: [
          '0187be21-8af4-5ecf-2ef0-cad831b85382',
        ],
      },
    },
    {
      name: 'Esport',
      url: 'esport',
      filters: {
        categoryIds: [
          '018fbe8c-7087-06b9-d828-96dddcbc4ed1',
        ],
      },
    },
    {
      name: 'Tech',
      url: 'tech',
      filters: {
        categoryIds: [
          '01883858-fbe6-4374-31b7-8abfdaabb3d8',
        ],
      },
    },
    {
      name: 'Recenze',
      url: 'recenze',
      filters: {
        categoryIds: [
          '0187be21-895a-1229-b5d4-0c0d02590d08',
        ],
      },
    },
    // {
    //   name: 'Newsletter',
    //   url: 'newsletter',
    // }
  ],
  [TemplateList.MATERIDOUSKA]: [
    {
      name: 'Pro děti',
      url: 'pro-deti',
      // filters: {
      //   categoryIds: [
      //     '01938940-b3fc-c8b7-3d7d-258ae3377920',
      //     '0193b112-390c-b014-7a3c-54dfb33ea8b7',
      //     '0193b0fd-afe0-c54f-7c7d-49f2b586d5d1',
      //     '01938940-9ccd-782d-93e9-74f15003d275',
      //     '0193b112-8e2a-ce70-d23f-3f5d560f6c40',
      //   ],
      // },
      items: [
        {
          name: 'Dílnička',
          url: 'dilnicka',
          filters: {
            categoryIds: [
              '01938940-b3fc-c8b7-3d7d-258ae3377920',
              '0193b112-390c-b014-7a3c-54dfb33ea8b7',
            ],
          }
        },
        {
          name: 'Soutěže',
          url: 'souteze',
          filters: {
            categoryIds: [
              '0193b0fd-afe0-c54f-7c7d-49f2b586d5d1',
              '01938940-9ccd-782d-93e9-74f15003d275',
            ],
          }
        },
        {
          name: 'Komnata',
          url: 'komnata',
          filters: {
            categoryIds: [
              '0193b112-8e2a-ce70-d23f-3f5d560f6c40',
            ],
          }
        },
      ],
    },
    {
      name: 'Pro rodiče',
      url: 'pro-rodice',
      // filters: {
      //   categoryIds: [
      //     '01938940-b3fc-c8b7-3d7d-258ae3377920',
      //     '01938940-928c-9d76-196d-500718d10fad',
      //     '0193b10f-deba-74c2-293b-f64ad1eb8ffb',
      //   ],
      // },
      items: [
        {
          name: 'Tvoření',
          url: 'tvoreni',
          filters: {
            categoryIds: [
              '01938940-b3fc-c8b7-3d7d-258ae3377920',
            ],
          }
        },
        {
          name: 'Recepty',
          url: 'recepty',
          filters: {
            categoryIds: [
              '01938940-928c-9d76-196d-500718d10fad',
              '0193b10f-deba-74c2-293b-f64ad1eb8ffb',
            ],
          },
        },
      ],
    },
    {
      name: 'Podcasty',
      url: 'podcasty',
      // filters: {
      //   categoryIds: [
      //     '0193b115-cf7c-8b83-8a37-37f6a8787c23',
      //     '01938940-ae59-f28e-dce1-87d7826920e3',
      //     '0193b117-3245-65b9-6abe-1f7cd06c1e00',
      //   ],
      // },
      items: [
        {
          name: 'Pro děti',
          url: 'podcasty-pro-deti',
          filters: {
            categoryIds: [
              '0193b115-cf7c-8b83-8a37-37f6a8787c23',
            ],
          },
        },
        {
          name: 'Pro rodiče',
          url: 'podcasty-pro-rodice',
          filters: {
            categoryIds: [
              '01938940-ae59-f28e-dce1-87d7826920e3',
              '0193b117-3245-65b9-6abe-1f7cd06c1e00',
            ],
          },
        },
        {
          name: 'Dětská rádia',
          url: 'https://www.pigy.cz/radia/',
          target: '_blank',
        },
      ],
    },
    {
      name: 'Akce a soutěže',
      url: 'akce-a-souteze',
      // filters: {
      //   categoryIds: [
      //     '0193b0fd-afe0-c54f-7c7d-49f2b586d5d1',
      //     '01938940-9ccd-782d-93e9-74f15003d275',
      //     '01938941-26b0-d07f-7be3-8f224aafc61e',
      //     '0193b114-cf4e-2183-940a-b1055c41374d',
      //   ],
      // },
      items: [
        {
          name: 'Soutěže',
          url: 'souteze',
          filters: {
            categoryIds: [
              '0193b0fd-afe0-c54f-7c7d-49f2b586d5d1',
              '01938940-9ccd-782d-93e9-74f15003d275',
            ],
          }
        },
        {
          name: 'Akce',
          url: 'akce',
          filters: {
            categoryIds: [
              '01938941-26b0-d07f-7be3-8f224aafc61e',
              '0193b114-cf4e-2183-940a-b1055c41374d',
            ],
          },
        },
      ],
    },
    {
      name: 'O nás',
      url: 'redakce',
    },
    {
      name: 'Newsletter',
      url: 'newsletter',
    }
  ],
}